const emptyPageContent = {
  heading: {},
  preamble: {},
}

const galleryPropsChange = ({ data }) => ({
  pageContent:
    (data && (data.contentPage || data.contentPageContent)) || emptyPageContent,
})

export default galleryPropsChange
